import apiHttpClient from "./ApiHttpService";

export default class TaskService {
  getTasks() {
    return apiHttpClient.get(
      `trs/mobile/Tasks/getTasks`
    );
  }
  getSubTasks(workDate) {
    return apiHttpClient.get(
      `trs/mobile/Tasks/getSubTasks/${workDate}`
    );
  }
  getAllSubTasks() {
    return apiHttpClient.get(
      `trs/mobile/Tasks/getAllSubTasks`
    );
  }
  createWorkRegistrationSubTask(model) {
    return apiHttpClient.post(
      "trs/mobile/Tasks/createWorkRegistrationSubTask",
      model
    );
  }
  deleteWorkRegistrationSubTask(id) {
    return apiHttpClient.delete(
      `trs/mobile/Tasks/deleteWorkRegistrationSubTask/${id}`
    );
  }
  getSubTasksByWorkRegistrationId(id) {
    return apiHttpClient.get(
      `trs/mobile/Tasks/getSubTasksByWorkRegistrationId/${id}`
    );
  }
}
